import styled from "styled-components";

export const Card = styled.fieldset`
  background-color: ${(props) => props.theme.colors.color11};
  margin: 3vw;
  padding: 1vw 3vw;
  box-sizing: border-box;
  justify-content: center;
  border-radius: 30px;
  align-items: center;
  justify-items: stretch;
  border: 1px solid ${(props) => props.theme.colors.color422};
`;

export const Room = styled(Card)``;
